import { render, staticRenderFns } from "./upload-zip.vue?vue&type=template&id=571277fb&scoped=true"
import script from "./upload-zip.vue?vue&type=script&lang=js"
export * from "./upload-zip.vue?vue&type=script&lang=js"
import style0 from "./upload-zip.vue?vue&type=style&index=0&id=571277fb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571277fb",
  null
  
)

export default component.exports